import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Page, BackButtonTitle } from 'src/components-dummy';
import { useAppSelector } from 'src/hooks';
import { TourAndGallerySettings } from 'src/components-bl/TourAndGallery';
import { tourAndGalleryActionsMethods } from 'src/components-bl/TourAndGallery/Actions/TourAndGalleryActions';
import { ShopRoutes } from '../../types/enums/shop-routes';

export const TourAndGalleryContainer = (): JSX.Element => {
  const dispatch = useDispatch();
  const shopId = useAppSelector(state => state.shop.current?.shopId);
  const { settings, isLoading } = useAppSelector(state => state.tourAndGallery);
  const languages = useAppSelector(state => state.meta.languages);
  const navigationPath = `/shops/${shopId}/${ShopRoutes.ShopperExperiences}`;

  useEffect(() => {
    if (shopId) {
      dispatch(tourAndGalleryActionsMethods.fetchSettings({ shopId }));
    }
  }, [shopId, dispatch]);

  return (
    <Page className='tour-and-gallery-container'>
      <Page.Header>
        <BackButtonTitle path={navigationPath}>Tour &amp; Gallery</BackButtonTitle>
      </Page.Header>
      <Page.Content>
        {shopId && (
          <TourAndGallerySettings
            settings={settings}
            shopId={shopId}
            isLoading={isLoading}
            dispatch={dispatch}
            languages={languages}
          />
        )}
      </Page.Content>
    </Page>
  );
};
